module.exports = __webpack_public_path__ + "static/media/1_.61189614.png";